import React from 'react';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';

import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import ACButton from '../../atoms/ACButton';
import { getInternalBaseUrl } from '../../common/global.js';

import styles from './SparkList.module.scss';

export default class SparkList extends React.Component {
  onClickSpark = (id) => {
    this.props.onSelectSparkFunc(id);
  };

  onChangeSearchText = (e) => {
    if (isEmpty(e) || isEmpty(e.target)) return null;
    const { value = '' } = e.target;

    this.props.onChangeSearchTextFunc(value);
  };

  renderSparks() {
    const { sparks } = this.props;
    if (isEmpty(sparks)) return;

    return sparks.map((spark) => {
      return this.renderSpark(spark);
    });
  }

  renderSpark(givenSpark) {
    const { spark = {} } = this.props;
    const { id = '', name = '', note = {} } = givenSpark;
    const privateNote = note.private || '';

    let gotToSparkUrl = getInternalBaseUrl().sparks + '?id=' + id;
    let s = [styles.sparkListItem];
    if (givenSpark && givenSpark.id === spark.id) {
      s.push(styles.selected);
    }
    return (
      <ListItem className={s.join(' ')} key={givenSpark.id}>
        <div style={{ width: '100%' }}>
          <Link
            to={gotToSparkUrl}
            style={{ textDecoration: 'none', color: 'inherit', width: '100%', padding: '10px' }}
            onClick={() => this.onClickSpark(id)}
          >
            <div className={styles.sparkName}>{name}</div>
            <div className={styles.internal}>{privateNote}</div>
          </Link>
        </div>
      </ListItem>
    );
  }

  render() {
    const { onCreateSparkFunc } = this.props;
    return (
      <div className={styles.root}>
        <div className={styles.top}>
          <div className={styles.header}>
            Connection Spark List
            <Link
              to={getInternalBaseUrl().sparks + '?id='}
              style={{ textDecoration: 'none', color: 'inherit', padding: '10px' }}
            >
              <ACButton
                text={'Add'}
                icon={<AddCircleOutlineIcon key="iconAddSpark" />}
                key="btnAddSpark"
                onClickFunc={onCreateSparkFunc}
              />
            </Link>
          </div>
          <TextField
            id="simple-start-adornment"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            placeholder="Search"
            className={styles.search}
            value={this.props.searchText}
            onChange={this.onChangeSearchText}
          />
        </div>
        <div className={styles.bottom}>
          <List className={styles.sparkList}>{this.renderSparks()}</List>
        </div>
      </div>
    );
  }
}
